import useUserContext from '~/hooks/useUserContext';
import { useLocale } from '~/hooks/useLocale';

interface EventParams {
  [key: string]: string | number | boolean | undefined;
}

export const useEvent = () => {
  const { user } = useUserContext();
  const { currentLocale, nextRouter } = useLocale();

  const sendEvent = (eventName: string, customParams: EventParams = {}) => {
    try {
      // Common parameters to include with every event
      const commonParams = {
        userId: user?.id,
        path: nextRouter.asPath,
        isOnboarded: user?.isOnboarded,
        language: currentLocale?.language,
        country: currentLocale?.country,
        localeCode: currentLocale?.code,
      };

      // Merge custom parameters with common parameters
      const params = {
        ...commonParams,
        ...customParams,
      };

      if (process.env.NODE_ENV === 'development') {
        console.log('Event:', eventName, params);
      }

      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', eventName, params);
      } else {
        console.error(`Event tracking not available: ${eventName}`, params);
      }
    } catch (error) {
      console.error('Error tracking event:', error);
    }
  };

  return { sendEvent };
};
